import React from "react";
import "./Progress-Bar.scss";
import { motion } from "framer-motion/dist/framer-motion";

const ImageModal = ({ selectedImg, setSelectedImg }) => {
  const handleClick = (e) => {
    if (e.target.classList.contains("backdrop")) {
      setSelectedImg(null);
    }
  };

  return (
    <motion.div
      className="backdrop"
      onClick={handleClick}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{ position: "relative", left: "30%" }}
    >
      <motion.img
        src={selectedImg}
        alt="enlarged pic"
        initial={{ y: "100vh" }}
        animate={{ y: 0 }}
      />
    </motion.div>
    // <div className="backdrop" onClick={handleClick} style={{position: "relative", left: '30%'}}>
    //     <img src={selectedImg} alt="enlarged pic"/>
    // </div>
  );
};

export default ImageModal;
